/**
 * The lang saved to the localStorage.
 */
export const SUPPORTED_LANGUAGES = [
  {
    locale: 'en',
    name: 'English',
    default: true,
  },
  {
    locale: 'zh',
    name: '中文',
  }
]
export function setLang(lang) {
  window.localStorage.setItem("user_lang", lang);
}
export function getLang(defaultLang) {
  let localLang = window.localStorage.getItem("user_lang");

  if (localLang === null) {
    return defaultLang;
  } else {
    return localLang;
  }
}
export function langInit(locale) {
  document.body.classList.remove("lang_zh");
  document.body.classList.remove("lang_en");
  document.getElementById("app").classList.remove("lang_en");
  document.getElementById("app").classList.remove("lang_zh");
  document.body.classList.add("lang_" + locale);
  document.getElementById("app").classList.add("lang_" + locale);
}
export function changeLang(locale) {
  setLang(locale);
  langInit(locale)
}
